define('drops/chart_v2/Chart_v2Defaults',[], function () {
    const defaultFontSettingsMain = {
        fontFamily: 'Arial',
        size: 14,
        weight: 'normal',
        color: 'rgba(0, 0, 0, 1)'
    };

    const defaultFontSettingsSecondary = {
        fontFamily: 'Arial',
        size: 14,
        weight: 'normal',
        color: 'rgba(255, 255, 255, 1)'
    };

    const defaultRoundedCorners = {
        enabled: false,
        leftBottomRadius: 6,
        leftTopRadius: 6,
        rightBottomRadius: 6,
        rightTopRadius: 6
    };

    const defaultPadding = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    };

    var designDefaults = {
        data: {

            labelType: 'value',
            backgroundColor: 'rgba(255, 255, 255, 0)',
            chartPadding: defaultPadding,

            // axisX
            showXAxis: false,
            axisXColor: 'rgba(0, 0, 0, 0.1)',
            axisXWidth: 1,
            showXAxisLabel: false,
            axisXLabel: '',
            axisXLabelFont: defaultFontSettingsMain,
            axisXLabelAlignment: 'end',
            axisXLabelPadding: 4,
            showXAxisTicks: true,
            axisXTickColor: 'rgba(0, 0, 0, 1)',
            axisXTickWidth: 1,
            axisXTickLength: 8,
            axisXDashedTick: false,
            axisXDashedTickLength: 1,
            axisXDashedTickSpacing: 1,
            showXAxisTickLabels: true,
            axisXTickLabelAlignment: 'center',
            axisXTickLabelFont: defaultFontSettingsMain,
            axisXTickLabelPadding: 3,
            axisXTickLabelMirror: false,
            axisXLabelAutoSkip: true,
            axisXLabelAutoSkipPadding: 3,
            axisXLabelMinRotation: 0,
            axisXLabelMaxRotation: 0,

            // axisY
            showYAxis: false,
            axisYColor: 'rgba(0, 0, 0, 0.1)',
            axisYWidth: 1,
            showYAxisLabel: false,
            axisYLabel: '',
            axisYLabelFont: defaultFontSettingsMain,
            axisYLabelAlignment: 'end',
            axisYLabelPadding: 4,
            showYAxisTicks: true,
            axisYTickColor: 'rgba(0, 0, 0, 1)',
            axisYTickWidth: 1,
            axisYTickLength: 8,
            axisYDashedTick: false,
            axisYDashedTickLength: 1,
            axisYDashedTickSpacing: 1,
            showYAxisTickLabels: true,
            axisYTickLabelAlignment: 'center',
            axisYTickLabelFont: defaultFontSettingsMain,
            axisYTickLabelPadding: 3,
            axisYTickLabelMirror: false,
            axisYLabelAutoSkip: true,
            axisYLabelAutoSkipPadding: 3,
            axisYLabelMinRotation: 0,
            axisYLabelMaxRotation: 0,

            // axisY2
            showY2Axis: false,
            axisY2Color: 'rgba(0, 0, 0, 0.1)',
            axisY2Width: 1,
            showY2AxisLabel: false,
            axisY2Label: '',
            axisY2LabelFont: defaultFontSettingsMain,
            axisY2LabelAlignment: 'end',
            axisY2LabelPadding: 4,
            showY2AxisTicks: true,
            axisY2TickColor: 'rgba(0, 0, 0, 1)',
            axisY2TickWidth: 1,
            axisY2TickLength: 8,
            axisY2DashedTick: false,
            axisY2DashedTickLength: 1,
            axisY2DashedTickSpacing: 1,
            showY2AxisTickLabels: true,
            axisY2TickLabelAlignment: 'center',
            axisY2TickLabelFont: defaultFontSettingsMain,
            axisY2TickLabelPadding: 3,
            axisY2TickLabelMirror: false,
            axisY2LabelAutoSkip: true,
            axisY2LabelAutoSkipPadding: 3,
            axisY2LabelMinRotation: 0,
            axisY2LabelMaxRotation: 0,

            // gridX
            showXGrid: false,
            gridXColor: 'rgba(0, 0, 0, 0.1)',
            gridXLineWidth: 1,
            gridXDashedLine: false,
            gridXDashedLineLength: 1,
            gridXDashedLineSpacing: 1,

            // gridY
            showYGrid: false,
            gridYColor: 'rgba(0, 0, 0, 0.1)',
            gridYLineWidth: 1,
            gridYDashedLine: false,
            gridYDashedLineLength: 1,
            gridYDashedLineSpacing: 1,

            // title
            showTitle: false,
            titleText: '',
            titleFont: defaultFontSettingsMain,
            titleFullSize: false,
            titlePosition: 'top',
            titleAlignment: 'center',
            titlePadding: 10,

            // tooltip
            showTooltip: false,
            tooltipInteractionMode: 'nearest',
            tooltipInteractionIntersect: true,
            tooltipInteractionAxis: 'x',
            tooltipInteractionIncludeInvisible: false,
            tooltipPosition: 'average',
            tooltipPadding: defaultPadding,
            tooltipBoxPadding: 1,
            tooltipCaretPadding: 2,
            tooltipCaretSize: 5,
            tooltipBorderWidth: 0,
            tooltipBorderColor: 'rgba(0, 0, 0, 0)',
            tooltipRoundedCorners: defaultRoundedCorners,
            tooltipBackgroundColor: 'rgba(0, 0, 0, 0.8)',
            showTooltipTitle: true,
            tooltipTitleFont: defaultFontSettingsSecondary,
            tooltipTitleAlignment: 'left',
            tooltipTitleSpacing: 2,
            tooltipTitleMarginBottom: 6,
            showTooltipBody: true,
            tooltipBodyFont: defaultFontSettingsSecondary,
            tooltipBodyLabelType: 'value',
            tooltipBodyAlignment: 'left',
            tooltipBodySpacing: 2,
            tooltipUsePointStyle: false,
            tooltipShowColorBoxes: true,

            // legend
            showLegend: false,
            legendPosition: 'top',
            legendAlignment: 'center',
            legendMaxWidth: undefined,
            legendMaxHeight: undefined,
            legendDisableClick: true,
            legendLabelFont: defaultFontSettingsMain,
            legendItemShowBorder: false,
            legendItemBorderColor: 'rgba(0, 0, 0, 0.8)',
            legendItemBorderWidth: 1,
            legendItemBorderRadius: 0,
            legendItemBorderPadding: 5,
            legendLabelBoxWitdh: 40,
            legendLabelBoxHeight: 12,
            legendLabelAlignment: 'left',
            legendLabelPadding: 10,
            legendLabelUsePointStyle: false,
            legendLabelBoxRoundedCorners: 0,
            showLegendTitle: false,
            legendTitleText: '',
            legendTitleFont: defaultFontSettingsMain,
            legendTitlePadding: 10,
            legendHideNullSeries: true,

            // zoom
            enableZoom: false,
            enableZoomWheel: false,
            zoomWheelSpeed: 0.1,
            zoomWheelModifierKey: 'None',
            enableZoomDrag: false,
            zoomDragBacgroundColor: 'rgba(225, 225, 225, 0.3)',
            showScrollbar: false,
            scrollbarColor: 'rgba(0, 0, 0, 0.1)',
            scrollbarHeight: 15,
            scrollbarRoundedCorners: 0,
            enableZoomPinch: false,
            zoomMode: 'x',
            zoomScaleMode: 'x',

            // pan
            enablePanning: false,
            panningMode: 'x',
            panningModifierKey: 'None',

            // datalabels
            showDatalabels: false,
            datalabelFont: defaultFontSettingsMain,
            datalabelHideZero: false,
            datalabelMinPercentageThreshold: 0,
            datalabelAnchor: 'center',
            datalabelAlignment: 'center',
            datalabelOffset: 4,
            datalabelClamp: false
        }
    };

    return designDefaults;
});

